export default __webpack_public_path__ + "assets/media/tv.f6363ae9.png";